import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Renderer_SurveyComponentBase } from '../Renderer_SurveyComponentBase/Renderer_SurveyComponentBase.js';
import './Renderer_SurveyComponentScale.scss';
import { _className, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { SurveyQuestion_Scale } from '@app/advisor-shared';
export class Renderer_SurveyComponentScale extends Renderer_SurveyComponentBase {
    componentType = SurveyQuestion_Scale;
    renderNumber = (scaleNumber) => {
        const className = _className('scale-number', this.state.currentValue === scaleNumber && 'selected');
        return _jsx("div", { onClick: () => this.props.onChange(scaleNumber), className: className, children: scaleNumber }, scaleNumber);
    };
    renderInput = () => {
        return _jsxs(LL_H_C, { className: 'scale-body', children: [_jsx("div", { className: 'scale-label', children: "Not at all" }), _jsx(LL_H_C, { className: 'scale-numbers', children: Array.from({ length: 5 }, (_, i) => i + 1).map(index => this.renderNumber(index)) }), _jsx("div", { className: 'scale-label', children: "Very much" })] });
    };
}
//# sourceMappingURL=Renderer_SurveyComponentScale.js.map